import { AnimatedDivPropsType, useIsVisibleAnimation } from "@/lib/main";
import { CSSProperties } from "react";

export default function AnimatedDiv({
  animation,
  children,
  repeatCount,
}: AnimatedDivPropsType) {
  const [containerRef, isVisible] = useIsVisibleAnimation();
  const styles: CSSProperties = {
    animationIterationCount: repeatCount ? repeatCount : 1,
  };

  return (
    <div
      style={styles}
      className={isVisible ? animation : "animation__hide"}
      ref={containerRef}
    >
      {children}
    </div>
  );
}
